import './Scene.scss'
import { useEffect, useRef, useState, useContext } from 'react'

import Animation from './three'
import { setToRender, removeFromRender } from 'root/animator'
import { ControllerContext } from 'components/Controller/Controller'

import { events } from './three/constants'
import { screens } from 'components/sections/constants'

import { dispatchSetChanging } from './three/utils'

const state = {
  isLoaded: false
}

const Scene = ({ ...props }) => {
  const [ percent, setPercent ] = useState(0)
  const parent = useRef()
  const canvas = useRef()
  const { isLoaded, setIsLoaded, setEnableScroll, dispatchActive } = useContext(ControllerContext)
  const controllerContext = useContext(ControllerContext)

  useEffect(() => {
    const label = `Scene${Date.now()}`
    const animation = new Animation(parent.current, canvas.current, controllerContext)
    document.addEventListener(events.LOADING, setPercentOnUpdate)
    document.addEventListener('loaderdestroy', setLoaderDestroy)
    setToRender({
      label: label,
      handler: (time) => animation.render( time ),
      delay: 10
    })
    return () => { 
      document.removeEventListener(events.LOADING, setPercentOnUpdate)
      document.removeEventListener('loaderdestroy', setLoaderDestroy)
      animation.unmount()
      removeFromRender(label) 
    }
  }, [])
  function setPercentOnUpdate(e: any) {
    const percent = e.detail.percent
    setPercent( percent )
    if (percent > 98) {
      if (!state.isLoaded) {
        setIsLoaded(true)
        state.isLoaded = true
        dispatchActive(screens.HERO)

        // мини костыль из-за неудобства вызова из сцены...
        dispatchSetChanging(false, 1500)
        // 
      }
    } 
  }
  function setLoaderDestroy() {
    setIsLoaded(true)
    state.isLoaded = true
    dispatchSetChanging(false, 1500)
  }

  return (
    <div {...props} ref={parent} className="scene">
      <canvas ref={canvas}></canvas>
      { !isLoaded && <div className="loader">{ percent }%</div> }
    </div>
  )
}

export default Scene